import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { useTranslation } from "react-i18next";

// Full-bleed background section (soft beige gradient)
const Section = styled.section`
  ${tw`w-full flex flex-col items-center justify-center text-center`}
  background: linear-gradient(90deg, #133b8c 0%, #133b8c 100%);
  padding: 60px 16px;
`;

const Heading = styled.h2`
  ${tw`text-2xl md:text-3xl font-extrabold tracking-wide`}
  color: #FFFFFF;
  font-family: 'Urbanist', sans-serif;

`;

const Paragraph = styled.p`
  ${tw`max-w-4xl mx-auto`}
  color: #FFFFFF;
  line-height: 1.7;
`;

const Cta = styled.button`
  ${tw`mt-6 inline-flex items-center justify-center rounded`}
  background: #FFFFFF;
  color: #133b8c;
  padding: 10px 24px;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: all .2s ease;
  &:hover { background: #FFFFFF; }
`;

const AgencyIntroBanner = ({
  heading,
  content,
  ctaText,
  onCtaClick,
}) => {
  const { t } = useTranslation();
  const headingText = heading ?? t('agencyIntro.heading', 'H2 - CATCHY HEADLINE');
  const contentText = content ?? t('agencyIntro.content', "Agence de marketing digital spécialisée, forte de nombreuses années d'expérience dans le domaine, nous accompagnons les petites et grandes entreprises dans l'amélioration de leur présence en ligne et la différenciation de leurs concurrents.");
  const ctaLabel = ctaText ?? t('agencyIntro.cta', 'CTA');
  return (
    <Section>
      <Heading>{headingText}</Heading>
    <br/>
      <Paragraph>{contentText}</Paragraph>
      <Cta onClick={onCtaClick}>{ctaLabel}</Cta>
    </Section>
  );
};

export default AgencyIntroBanner;
